"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefixError = exports.ensureError = void 0;
function ensureError(error) {
    return error instanceof Error ? error : new Error(String(error));
}
exports.ensureError = ensureError;
function prefixError(prefix, error) {
    if (prefix) {
        error.message = `${prefix}: ${error.message}`;
    }
    return error;
}
exports.prefixError = prefixError;
//# sourceMappingURL=error.js.map